import { Horizontal, Texto } from '@gravitate-js/excalibrr'
import { Checkbox, type CheckboxChangeEvent, Form, Select } from 'antd'
import type { FormItemProps } from 'antd/lib'
import { useCallback, useMemo } from 'react'
import { useScheduleItems } from '../../Context/ScheduleItems/ScheduleItemsContext'

export function DriversSelect(props: FormItemProps) {
  const form = Form.useFormInstance()
  const { rows } = useScheduleItems()
  const driverOptions = useMemo(() => rows?.map((x) => ({ label: x.name, value: x.id })) ?? [], [rows])
  const onSelectAll = useCallback(
    ({ target: { checked } }: CheckboxChangeEvent) => {
      if (!props.name) return
      const valueToSet = checked ? driverOptions?.map((x) => x.value) : undefined
      form.setFieldValue(props.name, valueToSet ?? [])
    },
    [driverOptions, form, props.name]
  )
  return (
    <Form.Item
      {...props}
      label={
        <Horizontal justifyContent='space-between' alignItems='center'>
          <Texto>{props.label ?? 'Drivers'}</Texto>
          <Checkbox className='ml-3 mr-2' onChange={onSelectAll} />
          <Texto category='label' appearance='light'>
            Select all?
          </Texto>
        </Horizontal>
      }
      rules={[{ required: true, message: 'Please select at least one driver' }]}
    >
      <Select
        allowClear
        maxTagCount={5}
        showSearch
        optionFilterProp='label'
        mode='multiple'
        style={{ flex: 1 }}
        options={driverOptions}
        placeholder='Select Drivers'
      />
    </Form.Item>
  )
}
